<template>
<div style="height: 50px;padding-top:10px;margin-top: -30px">
  <div class="title-left all-three-point">
    <span style="font-family: CustomFont" v-if="$store.state.user.LoginResp.system_name && $store.state.user.LoginResp.system_name !== ''">{{$store.state.user.LoginResp.system_name}}</span>
    <span style="font-family: CustomFont" v-else>{{$store.state.user.orgname}}</span>
  </div>
  <div class="nav-right-list">
    <div class="item-nav" :class="indexActive === item.id ? 'active-select' : ''" v-for="item in menuList" :key="item.index" @click="changeMenu(item)">
      <img style="vertical-align: middle" :src="item.icon">&nbsp;
      <span>{{ item.title }}</span>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'orgNavBottom',
  data () {
    return {
      indexActive: 1,
      menuList: [
        // id 到 62
        // 新增菜单注意create下的 jiaold.com jiaold.cn 域名菜单
        {id: 1, path: '/dataScreen', icon: '/static/menuIcon/jkzj.png', title: '数据大屏', arr: []},
        {
          icon: '/static/menuIcon/yykb.png',
          id: 2,
          title: '运营看板',
          arr: [
            {
              path: '',
              name: '',
              isOpen: true,
              lists: [
                {id: 1, level1: 2, path: '/eventMonitor', name: '事件监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 2, level1: 2, path: '/checkInStatistics', name: '入住情况', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 3, level1: 2, path: '/siteMonitor', name: '位置监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 4, level1: 2, path: '/healthDetection', name: '健康监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/jcsj.png',
          id: 3,
          title: '基础数据',
          arr: [
            {
              path: '',
              name: '机构管理',
              isOpen: true,
              icon: '/static/menuIcon/jggl.png',
              lists: [
                {id: 5, level1: 3, path: '/organization', name: '组织管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 6, level1: 3, path: '/organizationInfo', name: '机构信息', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 7, level1: 3, path: '/institutionStaff', name: '机构人员', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 50, level1: 3, path: '/subsidyManagement', name: '补贴管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 8, level1: 3, path: '/account', name: '账号管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 61, level1: 3, path: '/feedback', name: '员工反馈', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 62, level1: 3, path: '/oldFeedBack', name: '家属/老人反馈', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '房间信息',
              isOpen: false,
              icon: '/static/menuIcon/fjgl.png',
              lists: [
                {id: 9, level1: 3, path: '/buildingLayer', name: '楼栋楼层', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 10, level1: 3, path: '/roomManagement', name: '房间管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 11, level1: 3, path: '/deviceOrg', name: '监护设备', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/jgyy.png',
          id: 4,
          title: '机构运营',
          arr: [
            {
              path: '',
              name: '老人信息',
              isOpen: true,
              icon: '/static/menuIcon/lrxx.png',
              lists: [
                {id: 12, level1: 4, path: '/oldPersonManagement', name: '老人档案', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 13, level1: 4, path: '/awaitList', name: '轮候登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '入住管理',
              isOpen: false,
              icon: '/static/menuIcon/rzgl.png',
              lists: [
                {id: 14, level1: 4, path: '/checkIn', name: '入住/退住', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 37, level1: 4, path: '/checkOutApprove', name: '退住审批', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 15, level1: 4, path: '/visitManagement', name: '探视管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 52, level1: 4, path: '/registInOut', name: '出入登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 16, level1: 4, path: '/deadlineWarn', name: '到期提醒', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 17, level1: 4, path: '/accommodationStatistics', name: '入住报表', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 36, level1: 4, path: '/historyRecords', name: '历史记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '财务管理',
              isOpen: false,
              icon: '/static/menuIcon/cwgl.png',
              lists: [
                {id: 51, level1: 4, path: '/goodsEscrow', name: '物品代管', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 20, level1: 4, path: '/rechargePay', name: '充值消费', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 21, level1: 4, path: '/chargeItem', name: '收费项目', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 22, level1: 4, path: '/financeStatistics', name: '财务统计', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 23, level1: 4, path: '/oldPersonCheck', name: '老人账单', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '餐饮管理',
              isOpen: false,
              icon: '/static/menuIcon/cygl.png',
              lists: [
                {id: 38, level1: 4, path: '/restaurantManagement', name: '餐厅管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 40, level1: 4, path: '/ingredientVendor', name: '食材供应商', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 24, level1: 4, path: '/rawMaterial', name: '食材管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 25, level1: 4, path: '/dishesManagement', name: '菜品管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 26, level1: 4, path: '/setMeal', name: '套餐管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 27, level1: 4, path: '/weekSupply', name: '每周供应', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                // {id: 54, level1: 4, path: '/weekMenu', name: '每周菜单', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 28, level1: 4, path: '/orderSet', name: '老人订餐', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
                // {id: 60, level1: 4, path: '/cashierDesk', name: '餐饮收银', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '安全管理',
              isOpen: false,
              icon: '/static/menuIcon/spaq.png',
              lists: [
                {id: 29, level1: 4, path: '/foodEvidence', name: '食物留样', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 30, level1: 4, path: '/foodSafetyRecord', name: '安全记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 47, level1: 4, path: '/safetyActivity', name: '消防活动管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 56, level1: 4, path: '/doorRecord', name: '门禁记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '活动管理',
              isOpen: false,
              icon: '/static/menuIcon/spaq.png',
              lists: [
                {id: 49, level1: 4, path: '/activityManagement', name: '活动记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '资产管理',
              isOpen: false,
              icon: '/static/menuIcon/spaq.png',
              lists: [
                {id: 48, level1: 4, path: '/goodsMaterials', name: '物资管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 55, level1: 4, path: '/fixedAssets', name: '固定资产', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/fwgz.png',
          id: 6,
          title: '服务管理',
          arr: [
            {
              path: '',
              name: '护理服务',
              isOpen: true,
              icon: '/static/menuIcon/hlfw.png',
              lists: [
                {id: 18, level1: 6, path: '/serviceProject', name: '类别设置', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 39, level1: 6, path: '/serviceRecord', name: '护理记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
                // {id: 18, level1: 6, path: '/serviceType', name: '类别设置', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                // {id: 39, level1: 6, path: '/serviceEvent', name: '护理记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            // {
            //   path: '',
            //   name: '订单服务',
            //   isOpen: true,
            //   icon: '/static/menuIcon/ddfw.png',
            //   lists: [
            //     {id: 19, level1: 6, path: '/serviceWorkOrder', name: '服务工单', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
            //     {id: 43, level1: 6, path: '/orderRecord', name: '工单记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
            //   ]
            // },
            {
              path: '',
              name: '用药提醒',
              isOpen: true,
              icon: '/static/menuIcon/yytx.png',
              lists: [
                {id: 44, level1: 6, path: '/medicationRegistration', name: '用药登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 45, level1: 6, path: '/todayReminder', name: '当日提醒', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '工作管理',
              isOpen: true,
              icon: '/static/menuIcon/yytx.png',
              lists: [
                {id: 53, level1: 6, path: '/dayWork', name: '电子排班', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/zhwl.png',
          id: 5,
          title: '智慧物联',
          arr: [
            {
              path: '',
              name: '设备管理',
              isOpen: true,
              icon: '/static/menuIcon/sbgl.png',
              lists: [
                {id: 34, level1: 5, path: '/deviceOrg', name: '监护设备', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 42, level1: 5, path: '/deviceStaff', name: '员工设备', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 59, level1: 5, path: '/faceDevice', name: '人脸设备', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '实时监控',
              isOpen: false,
              icon: '/static/menuIcon/sbgl.png',
              lists: [
                {id: 31, level1: 5, path: '/healthDetection', name: '健康监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 32, level1: 5, path: '/siteMonitor', name: '位置监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 46, level1: 5, path: '/videoMonitor', name: '视频监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 47, level1: 5, path: '/videoZg', name: '探访视频', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '',
              isOpen: true,
              icon: '',
              lists: [
                {id: 40, level1: 5, path: '/dealAlarm', name: '事件处理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 33, level1: 5, path: '/alarmService', name: '事件统计', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 35, level1: 5, path: '/healthData', name: '健康数据', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        }
      ]
    }
  },
  created () {
    console.log('LoginResp', this.$store.state.user.LoginResp)
    this.golobleObject.getChangeTab = this.getChangeTab // 点击orgNavWrap切换
    this.indexActive = this.$store.getters.get_is_indexActive
    // 1、管理员： admin
    //     机构养老院所有页面
    //
    //     2、值班员：csd
    //     可查看页面：
    // 数据大屏
    //     运营看板
    //     机构运营中：老人信息
    //     入住管理： 入住/退住、探视管理/到期提醒、历史记录
    //     服务管理
    //     智慧物联中： 事件处理、健康监控、位置监控、健康数据
    //
    //     3、护工：guest
    //     服务管理
    if (window.location.host === 'jiaold.com jiaold.cn') {
      // 对 jiaold.com jiaold.cn  域名，隐藏 每日菜单 菜单
      this.menuList = [
        {id: 1, path: '/dataScreen', icon: '/static/menuIcon/jkzj.png', title: '数据大屏', arr: []},
        {
          icon: '/static/menuIcon/yykb.png',
          id: 2,
          title: '运营看板',
          arr: [
            {
              path: '',
              name: '',
              isOpen: true,
              lists: [
                {id: 1, level1: 2, path: '/eventMonitor', name: '事件监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 2, level1: 2, path: '/checkInStatistics', name: '入住情况', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 3, level1: 2, path: '/siteMonitor', name: '位置监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 4, level1: 2, path: '/healthDetection', name: '健康监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/jcsj.png',
          id: 3,
          title: '基础数据',
          arr: [
            {
              path: '',
              name: '机构管理',
              isOpen: true,
              icon: '/static/menuIcon/jggl.png',
              lists: [
                {id: 5, level1: 3, path: '/organization', name: '组织管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 6, level1: 3, path: '/organizationInfo', name: '机构信息', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 7, level1: 3, path: '/institutionStaff', name: '机构人员', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 50, level1: 3, path: '/subsidyManagement', name: '补贴管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 8, level1: 3, path: '/account', name: '账号管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 61, level1: 3, path: '/feedback', name: '员工反馈', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 62, level1: 3, path: '/oldFeedBack', name: '家属/老人反馈', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '房间信息',
              isOpen: false,
              icon: '/static/menuIcon/fjgl.png',
              lists: [
                {id: 9, level1: 3, path: '/buildingLayer', name: '楼栋楼层', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 10, level1: 3, path: '/roomManagement', name: '房间管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 11, level1: 3, path: '/deviceOrg', name: '监护设备', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/jgyy.png',
          id: 4,
          title: '机构运营',
          arr: [
            {
              path: '',
              name: '老人信息',
              isOpen: true,
              icon: '/static/menuIcon/lrxx.png',
              lists: [
                {id: 12, level1: 4, path: '/oldPersonManagement', name: '老人档案', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 13, level1: 4, path: '/awaitList', name: '轮候登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '入住管理',
              isOpen: false,
              icon: '/static/menuIcon/rzgl.png',
              lists: [
                {id: 14, level1: 4, path: '/checkIn', name: '入住/退住', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 37, level1: 4, path: '/checkOutApprove', name: '退住审批', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 15, level1: 4, path: '/visitManagement', name: '探视管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 52, level1: 4, path: '/registInOut', name: '出入登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 16, level1: 4, path: '/deadlineWarn', name: '到期提醒', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 17, level1: 4, path: '/accommodationStatistics', name: '入住报表', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 36, level1: 4, path: '/historyRecords', name: '历史记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '财务管理',
              isOpen: false,
              icon: '/static/menuIcon/cwgl.png',
              lists: [
                {id: 51, level1: 4, path: '/goodsEscrow', name: '物品代管', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 20, level1: 4, path: '/rechargePay', name: '充值消费', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 21, level1: 4, path: '/chargeItem', name: '收费项目', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 22, level1: 4, path: '/financeStatistics', name: '财务统计', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 23, level1: 4, path: '/oldPersonCheck', name: '老人账单', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '餐饮管理',
              isOpen: false,
              icon: '/static/menuIcon/cygl.png',
              lists: [
                {id: 38, level1: 4, path: '/restaurantManagement', name: '餐厅管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 40, level1: 4, path: '/ingredientVendor', name: '食材供应商', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 24, level1: 4, path: '/rawMaterial', name: '食材管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 25, level1: 4, path: '/dishesManagement', name: '菜品管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 26, level1: 4, path: '/setMeal', name: '套餐管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 27, level1: 4, path: '/weekSupply', name: '每周供应', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 28, level1: 4, path: '/orderSet', name: '老人订餐', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 60, level1: 4, path: '/cashierDesk', name: '餐饮收银', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '安全管理',
              isOpen: false,
              icon: '/static/menuIcon/spaq.png',
              lists: [
                {id: 29, level1: 4, path: '/foodEvidence', name: '食物留样', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 30, level1: 4, path: '/foodSafetyRecord', name: '安全记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 47, level1: 4, path: '/safetyActivity', name: '消防活动管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 56, level1: 4, path: '/doorRecord', name: '门禁记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '活动管理',
              isOpen: false,
              icon: '/static/menuIcon/spaq.png',
              lists: [
                {id: 49, level1: 4, path: '/activityManagement', name: '活动记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '资产管理',
              isOpen: false,
              icon: '/static/menuIcon/spaq.png',
              lists: [
                {id: 48, level1: 4, path: '/goodsMaterials', name: '物资管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 55, level1: 4, path: '/fixedAssets', name: '固定资产', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/fwgz.png',
          id: 6,
          title: '服务管理',
          arr: [
            {
              path: '',
              name: '护理服务',
              isOpen: true,
              icon: '/static/menuIcon/hlfw.png',
              lists: [
                {id: 18, level1: 6, path: '/serviceProject', name: '类别设置', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 39, level1: 6, path: '/serviceRecord', name: '护理记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
                // {id: 18, level1: 6, path: '/serviceType', name: '类别设置', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                // {id: 39, level1: 6, path: '/serviceEvent', name: '护理记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '用药提醒',
              isOpen: true,
              icon: '/static/menuIcon/yytx.png',
              lists: [
                {id: 44, level1: 6, path: '/medicationRegistration', name: '用药登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 45, level1: 6, path: '/todayReminder', name: '当日提醒', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '工作管理',
              isOpen: true,
              icon: '/static/menuIcon/yytx.png',
              lists: [
                {id: 53, level1: 6, path: '/dayWork', name: '电子排班', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/zhwl.png',
          id: 5,
          title: '智慧物联',
          arr: [
            {
              path: '',
              name: '设备管理',
              isOpen: true,
              icon: '/static/menuIcon/sbgl.png',
              lists: [
                {id: 34, level1: 5, path: '/deviceOrg', name: '监护设备', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 42, level1: 5, path: '/deviceStaff', name: '员工设备', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 59, level1: 5, path: '/faceDevice', name: '人脸设备', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '实时监控',
              isOpen: false,
              icon: '/static/menuIcon/sbgl.png',
              lists: [
                {id: 31, level1: 5, path: '/healthDetection', name: '健康监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 32, level1: 5, path: '/siteMonitor', name: '位置监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 46, level1: 5, path: '/videoMonitor', name: '视频监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 47, level1: 5, path: '/videoZg', name: '探访视频', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '',
              isOpen: true,
              icon: '',
              lists: [
                {id: 40, level1: 5, path: '/dealAlarm', name: '事件处理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 33, level1: 5, path: '/alarmService', name: '事件统计', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 35, level1: 5, path: '/healthData', name: '健康数据', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        }
      ]
    }
    // 在 https://bh.jiaold.com:10443 下面隐藏收银菜单
    console.log(window.location.host)
    if (window.location.host !== 'bh.jiaold.com:10443') {
      this.menuList[3] = {
        icon: '/static/menuIcon/jgyy.png',
        id: 4,
        title: '机构运营',
        arr: [
          {
            path: '',
            name: '老人信息',
            isOpen: true,
            icon: '/static/menuIcon/lrxx.png',
            lists: [
              {id: 12, level1: 4, path: '/oldPersonManagement', name: '老人档案', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 13, level1: 4, path: '/awaitList', name: '轮候登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
            ]
          },
          {
            path: '',
            name: '入住管理',
            isOpen: false,
            icon: '/static/menuIcon/rzgl.png',
            lists: [
              {id: 14, level1: 4, path: '/checkIn', name: '入住/退住', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 37, level1: 4, path: '/checkOutApprove', name: '退住审批', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 15, level1: 4, path: '/visitManagement', name: '探视管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 52, level1: 4, path: '/registInOut', name: '出入登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 16, level1: 4, path: '/deadlineWarn', name: '到期提醒', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 17, level1: 4, path: '/accommodationStatistics', name: '入住报表', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 36, level1: 4, path: '/historyRecords', name: '历史记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
            ]
          },
          {
            path: '',
            name: '财务管理',
            isOpen: false,
            icon: '/static/menuIcon/cwgl.png',
            lists: [
              {id: 51, level1: 4, path: '/goodsEscrow', name: '物品代管', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 20, level1: 4, path: '/rechargePay', name: '充值消费', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 21, level1: 4, path: '/chargeItem', name: '收费项目', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 22, level1: 4, path: '/financeStatistics', name: '财务统计', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 23, level1: 4, path: '/oldPersonCheck', name: '老人账单', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
            ]
          },
          {
            path: '',
            name: '餐饮管理',
            isOpen: false,
            icon: '/static/menuIcon/cygl.png',
            lists: [
              {id: 38, level1: 4, path: '/restaurantManagement', name: '餐厅管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 40, level1: 4, path: '/ingredientVendor', name: '食材供应商', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 24, level1: 4, path: '/rawMaterial', name: '食材管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 25, level1: 4, path: '/dishesManagement', name: '菜品管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 26, level1: 4, path: '/setMeal', name: '套餐管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 27, level1: 4, path: '/weekSupply', name: '每周供应', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              // {id: 54, level1: 4, path: '/weekMenu', name: '每周菜单', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 28, level1: 4, path: '/orderSet', name: '老人订餐', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 60, level1: 4, path: '/cashierDesk', name: '餐饮收银', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
            ]
          },
          {
            path: '',
            name: '安全管理',
            isOpen: false,
            icon: '/static/menuIcon/spaq.png',
            lists: [
              {id: 29, level1: 4, path: '/foodEvidence', name: '食物留样', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 30, level1: 4, path: '/foodSafetyRecord', name: '安全记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 47, level1: 4, path: '/safetyActivity', name: '消防活动管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 56, level1: 4, path: '/doorRecord', name: '门禁记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
            ]
          },
          {
            path: '',
            name: '活动管理',
            isOpen: false,
            icon: '/static/menuIcon/spaq.png',
            lists: [
              {id: 49, level1: 4, path: '/activityManagement', name: '活动记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
            ]
          },
          {
            path: '',
            name: '资产管理',
            isOpen: false,
            icon: '/static/menuIcon/spaq.png',
            lists: [
              {id: 48, level1: 4, path: '/goodsMaterials', name: '物资管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
              {id: 55, level1: 4, path: '/fixedAssets', name: '固定资产', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
            ]
          }
        ]
      }
    }
    let role = this.$store.state.user.role
    if (role === 'superadmin') {
      for (let i = 0; i < this.menuList.length; i++) {
        if (this.menuList[i].id === 5) {
          let obj1 = {id: 57, level1: 5, path: '/padDevice', name: '信息终端', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
          this.menuList[i].arr[0].lists.push(obj1)
          let obj = {id: 58, level1: 5, path: '/deviceFactoryReset', name: '设备出厂设置', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
          this.menuList[i].arr[0].lists.push(obj)
        }
      }
    } else if (role === 'csd') {
      this.menuList = [
        {id: 1, icon: '/static/menuIcon/jkzj.png', title: '数据大屏', arr: []},
        {
          icon: '/static/menuIcon/yykb.png',
          id: 2,
          title: '运营看板',
          arr: [
            {
              path: '',
              name: '',
              isOpen: true,
              lists: [
                {id: 1, level1: 2, path: '/eventMonitor', name: '事件监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 2, level1: 2, path: '/checkInStatistics', name: '入住情况', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 3, level1: 2, path: '/siteMonitor', name: '位置监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 4, level1: 2, path: '/healthDetection', name: '健康监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/jgyy.png',
          id: 4,
          title: '机构运营',
          arr: [
            {
              path: '',
              name: '老人信息',
              isOpen: true,
              icon: '/static/menuIcon/lrxx.png',
              lists: [
                {id: 12, level1: 4, path: '/oldPersonManagement', name: '老人档案', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 13, level1: 4, path: '/awaitList', name: '轮候登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '入住管理',
              isOpen: false,
              icon: '/static/menuIcon/rzgl.png',
              lists: [
                {id: 14, level1: 4, path: '/checkIn', name: '入住/退住', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 15, level1: 4, path: '/visitManagement', name: '探视管理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 52, level1: 4, path: '/registInOut', name: '出入登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 16, level1: 4, path: '/deadlineWarn', name: '到期提醒', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 36, level1: 4, path: '/historyRecords', name: '历史记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/fwgz.png',
          id: 6,
          title: '服务管理',
          arr: [
            {
              path: '',
              name: '护理服务',
              isOpen: true,
              icon: '/static/menuIcon/hlfw.png',
              lists: [
                // {id: 18, level1: 6, path: '/serviceType', name: '护理项目', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 39, level1: 6, path: '/serviceRecord', name: '护理记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
                // {id: 39, level1: 6, path: '/serviceEvent', name: '护理记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '用药提醒',
              isOpen: true,
              icon: '/static/menuIcon/yytx.png',
              lists: [
                {id: 44, level1: 6, path: '/medicationRegistration', name: '用药登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 45, level1: 6, path: '/todayReminder', name: '当日提醒', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '工作管理',
              isOpen: true,
              icon: '/static/menuIcon/yytx.png',
              lists: [
                {id: 53, level1: 6, path: '/dayWork', name: '电子排班', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        },
        {
          icon: '/static/menuIcon/zhwl.png',
          id: 5,
          title: '智慧物联',
          arr: [
            {
              path: '',
              name: '',
              isOpen: true,
              icon: '',
              lists: [
                {id: 40, level1: 5, path: '/dealAlarm', name: '事件处理', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 31, level1: 5, path: '/healthDetection', name: '健康监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 32, level1: 5, path: '/siteMonitor', name: '位置监控', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 35, level1: 5, path: '/healthData', name: '健康数据', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        }
      ]
    } else if (role === 'guest') {
      this.menuList = [
        {
          icon: '/static/menuIcon/fwgz.png',
          id: 6,
          title: '服务管理',
          arr: [
            {
              path: '',
              name: '护理服务',
              isOpen: true,
              icon: '/static/menuIcon/hlfw.png',
              lists: [
                // {id: 18, level1: 6, path: '/serviceType', name: '护理项目', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 39, level1: 6, path: '/serviceRecord', name: '护理记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
                // {id: 39, level1: 6, path: '/serviceEvent', name: '护理记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '用药提醒',
              isOpen: true,
              icon: '/static/menuIcon/yytx.png',
              lists: [
                {id: 44, level1: 6, path: '/medicationRegistration', name: '用药登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
                {id: 45, level1: 6, path: '/todayReminder', name: '当日提醒', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            },
            {
              path: '',
              name: '工作管理',
              isOpen: true,
              icon: '/static/menuIcon/yytx.png',
              lists: [
                {id: 53, level1: 6, path: '/dayWork', name: '电子排班', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
              ]
            }
          ]
        }
      ]
    }
  },
  mounted () {
    this.getLists() // 刷新
  },
  watch: {
    // 监听NavBar导航路由
    '$route' (to, from) {
      this.$nextTick(() => {
      })
    }
  },
  methods: {
    getChangeTab (arr) {
      // console.log('orgNavWrap', arr)
      if (this.$route.path === '/dataScreen') {
        this.indexActive = 1
        this.$store.commit('set_is_indexActive', this.indexActive)
      } else {
        this.indexActive = arr[0].lists[0].level1
        this.$store.commit('set_is_indexActive', this.indexActive)
      }
    },
    getLists () {
      let vm = this
      if (this.$route.path === '/dataScreen') {
        this.indexActive = 1
        this.$store.commit('set_is_indexActive', this.indexActive)
      }
      if (this.indexActive !== 1) {
        for (let i = 0; i < this.menuList.length; i++) {
          if (this.indexActive === this.menuList[i].id) {
            setTimeout(() => {
              vm.golobleObject.getChangeMenu(this.menuList[i], false)
            }, 300)
          }
        }
      }
    },
    changeMenu (item) {
      if (item.id !== this.indexActive) {
        this.indexActive = item.id
        this.$store.commit('set_is_indexActive', this.indexActive)
        let path = false
        if (this.$route.path === '/dataScreen') { // 是否从 数据大屏 页面点击其他菜单 默认其他菜单第一个页面
          path = true
        }
        this.golobleObject.getChangeMenu(item, path)
      }
    }
  }
}
</script>

<style scoped>
.title-left{
  position: absolute;
  width: 400px;
  color: #ffffff;
  height: 40px;
  line-height: 36px;
  text-align: center;
  letter-spacing: 4px;
  font-size: 34px;
}
.nav-right-list{
  position: absolute;
  left: 460px;
  width: calc(100% - 600px);
  height: 45px;
}
.item-nav{
  margin-top: -7px;
  height: 54px;
  line-height: 54px;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  float: left;
  width: 130px;
  text-align: center;
}
.active-select{
  background: url("../../../assets/navbar/selectNav.png") no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/childNavBar/orgNavBottom.vue